/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export const en = {
    "auth": {
        "username": "Username",
        "password": "Password",
        "passwordConfirmation" : "Password confirmation",
        "choosePassword": "Choose a password",
        "passwordRules": "Rules",
        "atLeastOneLowercase": "At least one lowercase",
        "atLeastOneUppercase": "At least one uppercase",
        "atLeastOneNumeric": "At least one numeric",
        "atLeastOneSpecialCharacter": "At least one special character",
        "minimumNineCharacters": "Minimum 9 characters",
        "maximum32Characters": "Maximum 32 characters",
        "login": "Login",
        "login-details": "Login details",
        "users": "Users",
        "rights": "Rights",
        "description": "Description",
        "edit": "Edit",
        "language": "Language",
        "cancel": "Cancel",
        "save": "Save",
        "name": "Name",
        "add": "Add",
        "delete": "Delete",
        "authenticationLog": "Login history",
        "loginDate": "Login date",
        "error": {
          "bad-credentials": "Wrong username or password",
          'MaxAttemptsExceededException': 'Ati depasit numarul maxim admis de solicitari!',
          'AttemptsExceededExceptionPT1M': 'Too many requests! Try again in 1 minute',
          'AttemptsExceededExceptionPT1H': 'Too many requests! Try again in 1 hour',
          'AttemptsExceededExceptionPT1D': 'Too many requests! Try again in 1 day',
          'AttemptsExceededExceptionPT10D': 'Too many requests! Try again in 10 days',
          'AttemptsLeft4': 'You have 4 more attempts!',
          'AttemptsLeft3': 'You have 3 more attempts!',
          'AttemptsLeft2': 'You have 2 more attempts!',
          'AttemptsLeft1': 'You have 1 more attempt!',
          'blocked-user': 'User is temporarily blocked due to too many failed login attempts.'
        },
        'warnings': {
          'emailNullReference': 'To continue navigation to other pages, please set an email address!'
        },
        'errors': {
            'name': {
                'minlength': "Username must be at least 5 characters long.",
                'required': "The field is required"

            },
            'password': {
              'minlength': 'Password must be at least 5 characters long.',
              'minLength8': 'Password must be at least 8 characters long.',
              'required': "The field is required",
              'customPattern': "Password must contain at least one lowercase, at least one uppercase, at least one numeric, at least one special character, it must have minimum 8 characters and maximum 32 characters!",
              'requiredPassword': 'The password is mandatory!'
            },
            'passwordConfirmation':{
              'passwordConfirmationMatchError': 'Password confirmation does not match with the password',
              'requiredPassword ': 'The password confirmation is mandatory!',
              'customPattern': 'Password must contain at least one lowercase, at least one uppercase, at least one numeric, at least one special character, it must have minimum 8 characters and maximum 32 characters!'
            },
        },
        "activeTo": "Active to",
        "indefinitely": "Indefinitely",
        "itemsSelected": "{0} selected",
        "activeOpts": {
            "active": "Active",
            "inactive": "Inactive",
            "all": "All"
        },
        'validatePhoneNumber': 'Validate phone number',
        'validationCode': 'Validation code',
        'sendSmsValidation': 'Send SMS for validation',
        'validateCode': 'Validate code',
        'invalidCode': 'Incorrect validation code!',
        'invalidPhoneNumber': 'Invalid phone number',
        "otpCodeSuccess": "A message with the validation code was sent on your number!",
        "phoneNumberRequiredMessage": "It is required to have a valid phone number added!",
        "phoneNumberValidateSuccessMessage": "Phone number was validated!",
    }
}
